import React, { Component } from 'react';
import { ComposedChart, Bar, XAxis, YAxis, Legend, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

import DropDownMenu from '../DropDownMenu';
import {LIGHT_COLOUR, MIDDLE_COLOUR, HEAVY_COLOUR, getAPIPath, USER_TYPE, headersWithMethod, fetchAPI} from '../../constants';

import './LevelsBarChart.css';

class LevelsBarChart extends Component {

    constructor(props) {
        super(props);
        this.exportData = this.exportData.bind(this);
    }

    exportData() {        
        const APIPATH = getAPIPath(USER_TYPE.DOWNLOAD);
        fetchAPI(APIPATH + '/export', headersWithMethod('POST',
            JSON.stringify({                    
                "fields": ['name','light','middle','heavy'],
                "data": this.props.data, 
                "fileName": "Submission-History"
        }))).then((response) => {                     
            response.json().then((json) => {
                window.open(APIPATH + '/exports/' + json.file);
            });                               
            
        }).catch((error) =>{
            console.error('ERROR:', error);
        })
    }

    render() {     
        
        class SimpleBarChart extends Component {        
            render () {
                if (!this.props.data || this.props.data.length === 0) {
                    return null;
                }
                return (
                        <ResponsiveContainer height={500}>
                            <ComposedChart data={this.props.data}>
                                <XAxis dataKey="name" tick={{fill: 'white'}}/>
                                <YAxis tick={{fill: 'white'}} tickCount={5}/>
                                <CartesianGrid strokeDasharray="3 3"/>
                                <Tooltip/>
                                <Legend content={() => (
                                    <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', paddingTop: '8px' }}>
                                        {[
                                            { label: 'light', color: LIGHT_COLOUR },
                                            { label: 'middle', color: MIDDLE_COLOUR },
                                            { label: 'heavy', color: HEAVY_COLOUR },
                                        ].map(({ label, color }) => (
                                            <span key={label} style={{ display: 'flex', alignItems: 'center', gap: '4px', color: 'white' }}>
                                                <svg width="10" height="10"><rect width="10" height="10" fill={color} /></svg>
                                                {label}
                                            </span>
                                        ))}
                                    </div>
                                )} />
                                <Bar dataKey="light" fill={LIGHT_COLOUR} barSize={60} fillOpacity={0.9}/>
                                <Bar dataKey="middle" fill={MIDDLE_COLOUR} barSize={60} fillOpacity={0.9}/>
                                <Bar dataKey="heavy" fill={HEAVY_COLOUR} barSize={60} fillOpacity={0.9}/>
                            </ComposedChart>
                        </ResponsiveContainer>
                    );
             }
        }

        return (    
            <div id="levels-bar-chart" className="moduleContainer">   
                <h2>{this.props.title} <DropDownMenu exportEvent={this.exportData} /></h2>                         
                <SimpleBarChart data={this.props.data}/>                
            </div>
        );
    }
}

export default LevelsBarChart;